import { Injectable, Injector, inject } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { ImpersonationHttpHandler } from './impersonation-http-handler';

@Injectable({
    providedIn: 'root'
})
export class ImpersonatedHttpClient extends HttpClient {
    constructor() {
        const backend = inject(HttpBackend);
        const injector = inject(Injector);

        super(new ImpersonationHttpHandler(backend, injector));
    }
}
